module.exports = __webpack_public_path__ + "img/lunch.c40460a9.svg";